import $ from 'jquery';
import Api from '../util/Api';

if ($('.auth-access-token').length > 0) {
    const accessToken = $('.auth-access-token').val();
    const idToken = $('.auth-id-token').val();
    const refreshToken = $('.auth-refresh-token').val();

    Api.post('/api/user/login/', {
        access_token: accessToken,
        id_token: idToken,
        refresh_token: refreshToken,
    }).then((response) => {
        if (response.status == 'success') {
            window.location = response.url;
        } else {
            window.location = '/auth/failed/';
        }
    });
}

$('.auth-sms-form').submit(function (e) {
    e.preventDefault();
    const data = {
        sms_code: $('.control--sms-code input').val(),
        data: $('.sms-data').val()
    };
    Api.post('/api/user/sms-check/', data)
        .then((response) => {
            if (response.status == 'success') {
                window.location = '/personal';
            } else {
                $('.sms-auth-code').text('Введеный код неверен');
            }
        });
});

$('.control--sms-code input').keyup(() => {
    $('.sms-auth-code').text('');
});

$('.left-menu__logout').click(() => {
    window.location = `https://identity.artlife.ru/connect/endsession?post_logout_redirect_uri=${window.location.origin}/logout`;
});

if (window.location.pathname.indexOf('auth/failed') > 0) {
    setTimeout(() => {
        window.location = `https://identity.artlife.ru/connect/endsession?post_logout_redirect_uri=${window.location.origin}/`;
    }, 1000);
}

let loginInProgress = false;
$('.auth-popup--login').submit(function (e) {
    e.preventDefault();
    const popup = $(this).parents('.popup');
    const button = popup.find('.popup-form__submit');
    const errorText = popup.find('.popup__error');

    if (loginInProgress) {
        return;
    }
    loginInProgress = true;

    errorText.hide();
    button.val('Signing in...');

    Api.post('/api/user/login/', {
        login: $('.auth-popup--login .popup-form__input--login').val(),
        password: $('.auth-popup--login .popup-form__input--password').val()
    }).then((response) => {
        if (response.status === 'success') {
            if (window.location.pathname.indexOf('/order') === 0) {
                window.location.reload(false);
            } else {
                window.location = response.url;
            }
        } else {
            errorText.text(response.errorMessage).show();
            button.val('Login');
            loginInProgress = false;
        }
    });
});
